// extracted by mini-css-extract-plugin
module.exports = {"base":"8px","locationContentTop":"locationFilter_locationContentTop__u3wvt","icon":"locationFilter_icon__4wK4w"};